export const exteriorView08ImageOptions = {
  angle: 'ExteriorView08',
  staticOptions: {
    HullColorways: 1,
    Bowsprit: 1,
    HullTreatment: 1,
    BathingLadder: 1,
    CockpitLockers: 1,
    RemovableFootChocks: 1,
    RemovableCockpitTable: 1,
    RemovableCompass: 1,
    Sprayhood: 1,
    MastAndBoom: 1,
    BoomCover: 1,
    Mainsail: 1,
    Flag: 1
  },
  mattes: [
    {
      option: 'HullColorways',
      dependency: null
    },
    {
      option: 'BathingLadder',
      dependency: null
    },
    {
      option: 'RemovableCockpitTable',
      dependency: null
    },
    {
      option: 'RemovableCompass',
      dependency: null
    },
    {
      option: 'Sprayhood',
      dependency: null
    },
    {
      option: 'MastAndBoom',
      dependency: null
    },
    {
      option: 'BoomCover',
      dependency: null
    },
    {
      option: 'Mainsail',
      dependency: null
    }
  ],
  overlays: []
}



// WEBPACK FOOTER //
// ./src/Xr41/views/ExteriorView08.js